import { render, staticRenderFns } from "./purshensing.vue?vue&type=template&id=aba238aa&scoped=true&"
import script from "./purshensing.vue?vue&type=script&lang=js&"
export * from "./purshensing.vue?vue&type=script&lang=js&"
import style0 from "./purshensing.vue?vue&type=style&index=0&id=aba238aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba238aa",
  null
  
)

export default component.exports